import { client } from '@/client';
import { OsintTransparencyResponse } from '@/client/accounts/types/osint-transparency.type';
import { GenericForbiddenApiError } from '@/hooks/query/types';
import { useQuery } from 'react-query';

const QUERY_KEY = 'osint-transparency';

export const useOsintTransparency = (
  accountId: string,
  enabled: boolean,
): {
  data: OsintTransparencyResponse | undefined;
  isLoading: boolean;
} => {
  const { data, isLoading } = useQuery<
    OsintTransparencyResponse,
    GenericForbiddenApiError
  >(
    [QUERY_KEY, accountId],
    () => client.accountOsint.getTransparency(accountId),
    {
      enabled: !!accountId && enabled,
      staleTime: 5 * 60 * 1000,
    },
  );

  return { data, isLoading };
};

export const OSINT_TRANSPARENCY_QUERY_KEY = QUERY_KEY;
